  
export default {
  primary: "#357edd",
  inverse: "#fff",
  // colors
  darkGrey: "#333447",
  black: "#000",

  // grid
  width: "96%",
  wrapperWidth: "65rem",
  gutter: "4%",
  breakpointPhone: "850px",
  breakpointTablet: "1024px",
  breakpointLaptop: "1200px",
  breakpointLarge: "60em", // 960px

  // font
  fontFamily: "athelas, georgia, serif",
}